import invoiceHeader from "../../../assets/invoice_header.svg";
import Image from "../../../components/Image";

export default function ItemInvoiceHeader({ invoiceHeader }) {
  return (
    <div
      className="u-width_full-width u-margin--bottom_400  u-margin--top_300 o-row o-row--horizontal-align_center"
      style={{
        background: "linear-gradient(135deg, #CCCBC8, #C1BFB8)",
      }}
    >
      {invoiceHeader ? (
        <Image
          className="u-width_full-width"
          imagePath={invoiceHeader}
          mode="show"
          imgClasses="u-width_full-width"
        />
      ) : null}
    </div>
  );
}
